export default "__VITE_ASSET__589e6aa2__"